const UPDATE_KYB_MUTATION = `mutation UpdateKybMutation(
  $kybId: ID!,
  $rawKybCustomerFacingName: String!,
  $rawKybLegalName: String!,
  $kybType: KYB_TYPE!,
  $kybStructure: KYB_STRUCTURE!,
  $rawKybUrl: String!,
  $rawKybPhoneNumber: String!,
  $rawKybTaxId: String!,
  $rawKybAddress: VaultAddressUpdateInput!
  ) {
  vaultKybUpdate(
    id: $kybId,
    legalName: $rawKybLegalName,
    customerFacingName: $rawKybCustomerFacingName,
    type: $kybType,
    structure: $kybStructure,
    url: $rawKybUrl,
    phoneNumber: $rawKybPhoneNumber,
    taxId: $rawKybTaxId,
    address: $rawKybAddress,
  )
}`;

export const requestBodyFormatter =
  ({
    kybId,
    kybBusinessStructure,
    kybBusinessType,
    kybAddressRegion,
  }: {
    kybId: string;
    kybBusinessStructure: string;
    kybBusinessType: string;
    kybAddressRegion: string;
  }) =>
  (formValues: Record<string, string>): VgsRequestBody => ({
    query: UPDATE_KYB_MUTATION,
    variables: {
      kybId,
      rawKybLegalName: formValues.kybLegalName,
      rawKybCustomerFacingName: formValues.kybCustomerFacingName,
      kybType: kybBusinessType,
      kybStructure: kybBusinessStructure,
      rawKybUrl: formValues.kybUrl,
      rawKybPhoneNumber: formValues.kybPhoneNumber,
      rawKybTaxId: formValues.kybTaxId,
      rawKybAddress: {
        street: formValues.kybAddressStreet,
        unit: formValues.kybAddressUnit,
        city: formValues.kybAddressCity,
        region: kybAddressRegion,
        postalCode: formValues.kybAddressPostalCode,
      },
      kybDescription: '',
    },
  });
